module.exports = __webpack_public_path__ + "img/wxHead2en.4a2a3cab.png";